<div class="about-us-container">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title">{{ t('aboutHero_title') }}</h1>
        <p class="hero-subtitle">{{ t('aboutHero_subtitle') }}</p>
      </div>
    </div>
  </div>

  <div class="container">
    <!-- Company Story Section -->
    <div class="company-story-section">
      <div class="row">
        <div class="col-lg-6">
          <div class="story-content">
            <h2 class="section-title">{{ t('aboutCompanyStory_title') }}</h2>
            <p class="story-text">
              {{ t('aboutCompanyStory_text1') }}
            </p>
            <p class="story-text">
              {{ t('aboutCompanyStory_text2') }}
            </p>
            <p class="story-text">
              {{ t('aboutCompanyStory_text3') }}
            </p>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="story-image">
            <img src="/heightHouse.jpeg" alt="{{ t('aboutCompanyStory_imageText') }}" />
          </div>
        </div>
      </div>
    </div>

    <!-- Mission & Vision Section -->
    <div class="mission-vision-section">
      <div class="row">
        <div class="col-lg-6">
          <div class="mission-card">
            <div class="card-icon">
              <i class="fas fa-bullseye"></i>
            </div>
            <h3>{{ t('aboutMission_title') }}</h3>
            <p>
              {{ t('aboutMission_text') }}
            </p>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="vision-card">
            <div class="card-icon">
              <i class="fas fa-eye"></i>
            </div>
            <h3>{{ t('aboutVision_title') }}</h3>
            <p>
              {{ t('aboutVision_text') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Values Section -->
    <div class="values-section">
      <h2 class="section-title text-center">{{ t('aboutValues_title') }}</h2>
      <div class="values-grid">
        <div class="value-card">
          <div class="value-icon">
            <i class="fas fa-leaf"></i>
          </div>
          <h4>{{ t('aboutValue1_title') }}</h4>
          <p>{{ t('aboutValue1_text') }}</p>
        </div>

        <div class="value-card">
          <div class="value-icon">
            <i class="fas fa-flask"></i>
          </div>
          <h4>{{ t('aboutValue2_title') }}</h4>
          <p>{{ t('aboutValue2_text') }}</p>
        </div>

        <div class="value-card">
          <div class="value-icon">
            <i class="fas fa-heart"></i>
          </div>
          <h4>{{ t('aboutValue3_title') }}</h4>
          <p>{{ t('aboutValue3_text') }}</p>
        </div>

        <div class="value-card">
          <div class="value-icon">
            <i class="fas fa-shield-alt"></i>
          </div>
          <h4>{{ t('aboutValue4_title') }}</h4>
          <p>{{ t('aboutValue4_text') }}</p>
        </div>

        <div class="value-card">
          <div class="value-icon">
            <i class="fas fa-handshake"></i>
          </div>
          <h4>{{ t('aboutValue5_title') }}</h4>
          <p>{{ t('aboutValue5_text') }}</p>
        </div>

        <div class="value-card">
          <div class="value-icon">
            <i class="fas fa-globe"></i>
          </div>
          <h4>{{ t('aboutValue6_title') }}</h4>
          <p>{{ t('aboutValue6_text') }}</p>
        </div>
      </div>
    </div>

    <!-- Team Section -->
    <!-- <div class="team-section">
      <h2 class="section-title text-center">Meet Our Team</h2>
      <div class="team-grid">
        <div class="team-member">
          <div class="member-photo">
            <div class="photo-placeholder">
              <i class="fas fa-user-md"></i>
            </div>
          </div>
          <h4>Dr. Rajesh Sharma</h4>
          <p class="member-role">Founder & CEO</p>
          <p class="member-bio">
            A renowned Ayurvedic physician with over 20 years of experience in natural medicine. 
            His passion for helping people achieve their height goals led to the creation of Height Gain.
          </p>
        </div>

        <div class="team-member">
          <div class="member-photo">
            <div class="photo-placeholder">
              <i class="fas fa-user-graduate"></i>
            </div>
          </div>
          <h4>Dr. Priya Patel</h4>
          <p class="member-role">Head of Research</p>
          <p class="member-bio">
            A PhD in Pharmacology with expertise in natural product development. 
            She leads our research team in creating innovative, effective formulations.
          </p>
        </div>

        <div class="team-member">
          <div class="member-photo">
            <div class="photo-placeholder">
              <i class="fas fa-user-tie"></i>
            </div>
          </div>
          <h4>Amit Kumar</h4>
          <p class="member-role">Operations Director</p>
          <p class="member-bio">
            Ensures smooth operations and maintains the highest quality standards 
            in our manufacturing and distribution processes.
          </p>
        </div>
      </div>
    </div> -->

    <!-- Statistics Section -->
    <div class="stats-section">
      <div class="stats-grid">
        <div class="stat-item">
          <div class="stat-number">10,000+</div>
          <div class="stat-label">{{ t('aboutStats_customers') }}</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">95%</div>
          <div class="stat-label">{{ t('aboutStats_successRate') }}</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">10+</div>
          <div class="stat-label">{{ t('aboutStats_experience') }}</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">24/7</div>
          <div class="stat-label">{{ t('aboutStats_support') }}</div>
        </div>
      </div>
    </div>

    <!-- Certifications Section -->
    <div class="certifications-section">
      <h2 class="section-title text-center">{{ t('aboutCertifications_title') }}</h2>
      <div class="certifications-grid">
        <div class="certification-item">
          <div class="cert-icon">
            <i class="fas fa-certificate"></i>
          </div>
          <h4>{{ t('aboutCert1_title') }}</h4>
          <p>{{ t('aboutCert1_text') }}</p>
        </div>
        <div class="certification-item">
          <div class="cert-icon">
            <i class="fas fa-award"></i>
          </div>
          <h4>{{ t('aboutCert2_title') }}</h4>
          <p>{{ t('aboutCert2_text') }}</p>
        </div>
        <div class="certification-item">
          <div class="cert-icon">
            <i class="fas fa-leaf"></i>
          </div>
          <h4>{{ t('aboutCert3_title') }}</h4>
          <p>{{ t('aboutCert3_text') }}</p>
        </div>
        <div class="certification-item">
          <div class="cert-icon">
            <i class="fas fa-shield-alt"></i>
          </div>
          <h4>{{ t('aboutCert4_title') }}</h4>
          <p>{{ t('aboutCert4_text') }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
